import $ from 'jquery';

import { sidebarImageInjectionLoader } from '~src/image';
import { addMagicFrameToCanvas } from '~core/magicFrame';
import { handleMagicFrameFrameSelection } from '~core/magicFrame';
import { getState, modifyState } from '~src/state';

// TODO: this should never happen unless the image in the DB has missing width/height
function getMeta(url) {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject();
    img.src = url;
  });
}

export const onAddMagicFrameToCanvas = async (event) => {
  event.preventDefault();

  const url = $(event.currentTarget).data('url');
  const svgClip = $(event.currentTarget).data('svg-clip');
  let width = $(event.currentTarget).data('width');
  let height = $(event.currentTarget).data('height');

  if (!width || !height || width === 'undefined' || height === 'undefined') {
    const img = await getMeta(url);
    width = img.width;
    height = img.height;
  }

  // TODO: check if width/height is bigger than the canvas itself

  if (getState('magicFrameSelectFramePhotoActive')) {
    await handleMagicFrameFrameSelection(url, width, height, svgClip);
    return;
  }

  // Flow: Add Magic Frame from selected Image ("Aggiungi Cornice")
  const addFromImageActive = getState('magicFrameAddFromImageActive');
  const source = getState('magicFrameAddFromImageSource');

  $(event.currentTarget).append(sidebarImageInjectionLoader);

  if (addFromImageActive && source) {
    try {
      // Create a MagicFrame using the frame intrinsic size (respect its aspect)
      const magicFrame = await addMagicFrameToCanvas({
        frameUrl: url,
        width,
        height,
        svgClip,
      });

      // Compute target center based on original image origin
      let targetLeft = source.left;
      let targetTop = source.top;
      const scaledW = (source.width || 0) * (source.scaleX || 1);
      const scaledH = (source.height || 0) * (source.scaleY || 1);
      if (source.originX === 'left') {
        targetLeft = source.left + scaledW / 2;
      }
      if (source.originX === 'right') {
        targetLeft = source.left - scaledW / 2;
      }
      if (source.originY === 'top') {
        targetTop = source.top + scaledH / 2;
      }
      if (source.originY === 'bottom') {
        targetTop = source.top - scaledH / 2;
      }

      // Choose a uniform scale so frame aspect ratio is preserved.
      const scaleW = (scaledW || 0) / (width || 1);
      const scaleH = (scaledH || 0) / (height || 1);
      const finalH_ifW = height * scaleW;
      const finalW_ifH = width * scaleH;
      const errW = Math.abs((finalH_ifW || 0) - (scaledH || 0));
      const errH = Math.abs((finalW_ifH || 0) - (scaledW || 0));
      const useWidth = errW <= errH; // drive by width if it better matches
      const uniformScale = useWidth ? scaleW : scaleH;

      // Apply transforms (position/scale/rotation/flip)
      magicFrame.set({
        left: targetLeft,
        top: targetTop,
        angle: source.angle || 0,
        scaleX: uniformScale,
        scaleY: uniformScale,
        flipX: !!source.flipX,
        flipY: !!source.flipY,
        skewX: source.skewX || 0,
        skewY: source.skewY || 0,
        opacity: typeof source.opacity === 'number' ? source.opacity : 1,
      });
      if (source.globalCompositeOperation) {
        magicFrame.globalCompositeOperation = source.globalCompositeOperation;
      }
      if (source.shadow) {
        magicFrame.shadow = source.shadow;
      }

      // Apply original image filters to person layer on init
      try {
        if (Array.isArray(source.filters) && source.filters.length > 0) {
          if (typeof magicFrame.setEditingImgProps === 'function') {
            magicFrame.setEditingImgProps({
              ...(magicFrame.editingImgProps || {}),
              filters: source.filters,
            });
          } else {
            magicFrame.editingImgProps = {
              ...(magicFrame.editingImgProps || {}),
              filters: source.filters,
            };
          }
        }
      } catch (e) {
        console.error('Failed applying image filters to MagicFrame person', e);
      }

      // Use the original image as the person layer
      if (source.src) {
        await magicFrame.updatePerson(source.src);
        // Ensure person fits current frame width taking scale into account
        try {
          magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
          magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
        } catch (e) {
          console.error('Failed scaling MagicFrame person after update', e);
        }
      }

      // Remove the original image if it is still present on canvas
      try {
        const objs = window.canvas.getObjects() || [];
        const toRemove = objs.find(
          (o) =>
            o &&
            o.type === 'image' &&
            !o._magicFrame &&
            o.get &&
            o.get('giotto')?.objRefId === source.objRefId
        );
        if (toRemove) {
          window.canvas.remove(toRemove);
        }
      } catch (e) {
        console.error(
          'Failed removing original image after adding MagicFrame',
          e
        );
      }

      // Keep new MagicFrame selected
      try {
        window.canvas.setActiveObject(magicFrame);
        window.canvas.renderAll();
      } catch (e) {
        console.error('Failed selecting MagicFrame after insertion', e);
      }

      // Reset state flags
      await modifyState('magicFrameAddFromImageActive', false);
      await modifyState('magicFrameAddFromImageSource', null);

      $('.editor-sidebar-image-injection-loader').remove();
      return;
    } catch (e) {
      console.error('Errore durante Aggiungi Cornice', e);
      // fallthrough to default add if something goes wrong
    }
  }

  await addMagicFrameToCanvas({ frameUrl: url, width, height, svgClip });

  $('.editor-sidebar-image-injection-loader').remove();
};
